jQuery(document).ready(function($) {
	// Lazy load youtube videos
	// Select all youTube videos
	var youtubeVideos = document.querySelectorAll("#video_module.cms_list_carousel .video-file-youtube");

	// Loop through the videos
	for (var i = 0; i < youtubeVideos.length; i++) {
		// Get thumbnail image source.
		var thumbnailSource = "https://img.youtube.com/vi/"+ youtubeVideos[i].dataset.embed +"/sddefault.jpg";

		// Add video default image
		var image = new Image();
		image.src = thumbnailSource;
		image.alt = "";
		image.addEventListener("load", function() {
			youtubeVideos[i].appendChild(image);
		}(i));

		// Play video on click
		youtubeVideos[i].addEventListener( "click", function() {
			var iframe = document.createElement( "iframe" );
			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("allowfullscreen", "");
			iframe.setAttribute("src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1");

			this.innerHTML = "";
			this.appendChild(iframe);
		});
	}

	// Lazy load vimeo videos; their thumbnails are stored when the video is saved
	var vimeoVideos = document.querySelectorAll("#video_module.cms_list_carousel .video-file-vimeo");

	for (var j = 0; j < vimeoVideos.length; j++) {
		vimeoVideos[j].querySelector(".play-button").addEventListener("click", function() {
			var container = this.parentNode;
			var embedURL = container.dataset.embedUrl;
			var iframe = document.createElement("iframe");

			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
			iframe.setAttribute("allowfullscreen", "");
			iframe.setAttribute("title", container.dataset.title);
			iframe.setAttribute("src", embedURL + (embedURL.indexOf("?") === -1 ? "?" : "&") + "autoplay=1");

			container.innerHTML = "";
			container.appendChild(iframe);

			// Keep keyboard users on the player that replaced the button
			iframe.focus();
		});
	}
});
